export const DealAccessRequestStatus = {
    NONE: 'none',
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    DECLINED: 'declined',
};
